import { render, staticRenderFns } from "./board_password.vue?vue&type=template&id=74c6bd89&"
import script from "./board_password.vue?vue&type=script&lang=js&"
export * from "./board_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports